import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Avatar01 from "../../../assets/media/avatar-01.png";

import Header from "../../header";
import Navbar from "../../navbar";
import iconMenuDots from "../../../assets/media/icon-menu-dots.svg";
import moment from "moment";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import iconCaretDown from "../../../assets/media/icon-caret-down.svg";
import iconCaretLeft from "../../../assets/media/icon-caret-left.svg";
import iconCaretRight from "../../../assets/media/icon-caret-right.svg";
import iconFileDelete from "../../../assets/media/icon-file-delete.svg";
import iconFileDoc from "../../../assets/media/icon-file-doc.svg";
import iconFileDownload from "../../../assets/media/icon-file-download.svg";
import iconFileEdit from "../../../assets/media/icon-file-edit.svg";
import iconFileImage from "../../../assets/media/icon-file-image.svg";
import iconFilePdf from "../../../assets/media/icon-file-pdf.svg";
import iconFileXls from "../../../assets/media/icon-file-xls.svg";
import iconSearch from "../../../assets/media/icon-search.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/svgicons/ArrowLeft.svg";
import {
  fetchEmployeeApplications,
  fetchEmployeeById,
} from "../../../store/reducers/employeeSlice.js";
import "./styles.css";
import Pagination from "../dashboard/appPagination.js";
import userImagePlaceholder from "../../../assets/media/avatar2.png";
import { downloadUserApplicationsCsv } from "../../../helpers/csvExport";
import { notifyApiError, notifyApiSuccess } from "../../../helpers/apiNotify";
import { canDecideApplications } from "../../../utility/rbac";
import { DISCREPANCY_STATES } from "../../../utility/applicationCounts";
import { formatStatusLabel } from "../applications/statusConfirmDialog/statusConfirmDialog";

const columnHelper = createColumnHelper();

export const formatDate = (inputDate) => {
  if (!inputDate) return "";
  const date = new Date(inputDate);
  if (Number.isNaN(date.getTime())) return String(inputDate);
  const options = { year: "numeric", month: "long", day: "2-digit" };
  return date.toLocaleDateString(undefined, options);
};


const stateButtonMap = {
  in_process: { className: "status-inprocess", text: "In Process", state: "in_process" },
  pending: { className: "status-pending", text: "Pending", state: "pending" },
  pending_for_approval: { className: "status-pending", text: "Pending For Approval", state: "pending_for_approval" },
  approved: { className: "status-approved", text: "Approved", state: "approved" },
  rejected: { className: "status-rejected", text: "Rejected", state: "rejected" },
  discrepancies: { className: "status-discrepancies", text: "Discrepancies", state: "discrepancies" },
  discrepancy_GB_GB: { className: "status-discrepancies", text: "Discrepancies GB - Assigned to GB", state: "discrepancy_GB_GB" },
  descrepancy_GB_GB: { className: "status-discrepancies", text: "Discrepancies GB - Assigned to GB", state: "descrepancy_GB_GB" },
  discrepancy_GB_Company: { className: "status-discrepancies", text: "Discrepancies GB - Assigned to Company", state: "discrepancy_GB_Company" },
  descrepancy_GB_Company: { className: "status-discrepancies", text: "Discrepancies GB - Assigned to Company", state: "descrepancy_GB_Company" },
  discrepancy_GB_Employee: { className: "status-discrepancies", text: "Discrepancies GB - Assigned to Employee", state: "discrepancy_GB_Employee" },
  descrepancy_GB_Employee: { className: "status-discrepancies", text: "Discrepancies GB - Assigned to Employee", state: "descrepancy_GB_Employee" },
  drafts: { className: "status-drafts", text: "Drafts", state: "drafts" },
  draft: { className: "status-drafts", text: "Draft", state: "draft" },
  renewal: { className: "status-renewal", text: "Renewal", state: "renewal" },
  dicrepancy_application_assigned_to_company_user: { className: "status-discrepancies", text: "Discrepancies Company - Assigned to Employee", state: "dicrepancy_application_assigned_to_company_user" },
  discrepancy_application_assigned_to_employee_user: { className: "status-discrepancies", text: "Assigned to Employee", state: "discrepancy_application_assigned_to_employee_user" },
  application_sent_to_discrepancy_by_company: { className: "status-discrepancies", text: "Discrepancies Company - Assigned to Company", state: "application_sent_to_discrepancy_by_company" },
  application_submitted_by_company_user_to_company: { className: "status-inprocess", text: "In Review", state: "application_submitted_by_company_user_to_company" },
  assign_to_company: { className: "status-discrepancies", text: "Discrepancies Company - Assigned to Company", state: "assign_to_company" },
}

// Mapping between checkbox labels and API state values
const statusFilterMap = {
  "All": null,
  "Approved": "approved",
  "Rejected": "rejected",
  "In Process": "in_process",
  "Discrepancies": DISCREPANCY_STATES,
  "Renewal": "renewal",
  "Discrepancies Assigned to Company": [
    "discrepancy_GB_Company",
    "descrepancy_GB_Company",
    "application_sent_to_discrepancy_by_company",
    "assign_to_company",
  ],
  "Discrepancies Assigned to Employee": [
    "discrepancy_GB_Employee",
    "descrepancy_GB_Employee",
    "dicrepancy_application_assigned_to_company_user",
    "discrepancy_application_assigned_to_employee_user",
  ],
  "Drafts": "drafts",
}

const EmployeeDetails = () => {
  const initialState = {
    All: true,
    // 'Pending': false,
    Approved: false,
    Rejected: false,
    "In Process": false,
    // Discrepancies: false,
    // Drafts: false,
    // Renewal: false,
  };

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [checkboxes, setCheckboxes] = useState(initialState);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const employee = useSelector((state) => state.employee);
  const {
    applications: applicationRecords,
    applicationsLoading: applicationsLoader,
  } = useSelector((state) => state.employee);

  const users = employee?.user;
  const isLoading = employee?.fetchLoading;
  const authToken = user.access_token;
  const { id } = useParams();
  const navigate = useNavigate();
  const [downloadingCsv, setDownloadingCsv] = useState(false);

  const handleDownloadEmployeeApplicationsCsv = async () => {
    if (!authToken || !id || downloadingCsv) return;
    setDownloadingCsv(true);
    try {
      await downloadUserApplicationsCsv({
        accessToken: authToken,
        userId: id,
        fileName: `employee-${id}-applications`,
      });
      notifyApiSuccess("Employee applications CSV downloaded");
    } catch (err) {
      notifyApiError(err, "Failed to download employee applications CSV");
    } finally {
      setDownloadingCsv(false);
    }
  };

  function CheckboxFilter({ checkboxes, setCheckboxes, setSearchTerm }) {
    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      if (value === "All") {
        setCheckboxes((prevCheckboxes) => {
          const newCheckboxes = { ...prevCheckboxes };
          for (const key in newCheckboxes) {
            newCheckboxes[key] = checked;
          }
          return newCheckboxes;
        });
        setSearchTerm("");
      } else {
        setCheckboxes((prevCheckboxes) => ({
          ...prevCheckboxes,
          [value]: checked,
        }));
        setSearchTerm("");
      }
    };

    return (
      <div className="boardFilter">
        {Object.keys(checkboxes).map((checkboxValue) => (
          <div className="form-check form-check-inline" key={checkboxValue}>
            <input
              className="form-check-input"
              type="checkbox"
              value={checkboxValue}
              checked={checkboxes[checkboxValue]}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label">{checkboxValue}</label>
          </div>
        ))}
      </div>
    );
  }

  const handleInputChange = (event) => {
    filtered(event.target.value);
    setSearchTerm(event.target.value);
  };

  const filtered = useCallback((search = "") => {
    const filteredData = (applicationRecords || [])
      .filter((item) => {
        // If "All" is checked, show all items
        if (checkboxes["All"] === true) {
          return true;
        }

        // Get the application's state value
        const applicationState = item.state;

        // Check each checked checkbox to see if it matches the application state
        for (const checkboxLabel in checkboxes) {
          // Skip "All" and unchecked boxes
          if (checkboxLabel === "All" || checkboxes[checkboxLabel] !== true) {
            continue;
          }

          // Get the state value for this checkbox from statusFilterMap
          const expectedState = statusFilterMap[checkboxLabel];

          // If the state matches, include this item
          if (Array.isArray(expectedState)) {
            if (expectedState.includes(applicationState)) {
              return true;
            }
          } else if (expectedState && applicationState === expectedState) {
            return true;
          }

          // Also check via stateButtonMap / shared labels for additional matching
          const stateInfo = stateButtonMap[applicationState];
          const label = formatStatusLabel(applicationState);
          if (
            (stateInfo && stateInfo.text === checkboxLabel) ||
            label === checkboxLabel
          ) {
            return true;
          }
        }

        // If no checkbox matches, exclude this item
        return false;
      })
      .map((item) => ({
        ...item,
        stateText: formatStatusLabel(item.state),
        applicationId: item.applicationId || item.id,
      }))
      .filter((item) => {
        if (!search) return true;
        for (const key in item) {
          if (
            typeof item[key] === "string" &&
            item[key].toLowerCase().includes(search.toLowerCase())
          ) {
            return true;
          }
        }
        return false;
      });

    setData(filteredData);
    return filteredData;
  }, [applicationRecords, checkboxes]);
  const getTotalPages = () => {
    if (Number.isInteger(data?.length / 10)) return data?.length / 10;
    return Math.floor(data?.length / 10) + 1;
  };
  useEffect(() => {
    dispatch(fetchEmployeeById({ accessToken: authToken, userId: id }));
    dispatch(fetchEmployeeApplications({ accessToken: authToken, userId: id }));
  }, [authToken, dispatch, id]);

  useEffect(() => {
    if (applicationRecords) {
      filtered();
    }
  }, [applicationRecords, checkboxes, filtered]);

  // Paginated data for current page
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    return data.slice(startIndex, endIndex);
  }, [data, currentPage]);

  // React Table columns
  const columns = useMemo(
    () => [
      columnHelper.display({
        id: "serial",
        header: "S.NO.",
        cell: (info) => (currentPage - 1) * 10 + info.row.index + 1,
      }),
      columnHelper.display({
        id: "applicationNo",
        header: "Application No.",
        cell: (info) => `GB-${info.row.original.applicationId}`,
      }),
      columnHelper.display({
        id: "applicationName",
        header: "Application Name",
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="boardTitle">
              <strong title={row.name}>
                {row.name?.length > 50
                  ? `${row.name.substring(0, 50)}...`
                  : row.name}
              </strong>
              <span>{row.categoryName}</span>
            </div>
          );
        },
      }),
      columnHelper.display({
        id: "submittedDate",
        header: "Submitted Date",
        cell: (info) => {
          const row = info.row.original;
          return formatDate(row.submissionDate || '—');
        },
      }),
      columnHelper.display({
        id: "submittedDate By",
        header: "Submitted Date By",
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="boardTitle">
              <strong>{row.companyName || row.company_name || '—'}</strong>
              <span>{row.companyEmail || row.company_email || row.email || '—'}</span>
            </div>
          );
        },
      }),
      columnHelper.display({
        id: "status",
        header: "Status",
        cell: (info) => {
          const row = info?.row?.original;
          if (!row) return <span>—</span>;

          const stateInfo = stateButtonMap[row.state];
          return (
            <Link
              className={`reasonText boardButton ${stateInfo?.className || ""}`}
            >
              {formatStatusLabel(row.state)}
            </Link>
          );
        },
      }),
      columnHelper.display({
        id: "actions",
        header: "Actions",
        cell: (info) => {
          const row = info.row.original;
          return (
            <div className="boardActions">
              <div className="dropdown d-inline-flex">
                <button
                  className="application-dropdown dropdown-toggle border-0 bg-transparent"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={iconMenuDots} alt="Menu Dots" />
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                >
                  <li>
                    <Link
                      className="dropdown-item"
                      to={`/view-applications/${row.applicationId}`}
                    >
                      View
                    </Link>
                  </li>
                  {canDecideApplications(user) && (
                    <li>
                      <Link
                        className="dropdown-item"
                        to={`/delete-applications/${row.applicationId}`}
                      >
                        Delete
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          );
        },
      }),
    ],
    [currentPage, user]
  );

  const table = useReactTable({
    data: paginatedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      <div>
        <Navbar />
        <Header />
        {isLoading ? (
          <div className="wrapper emp-details-wrapper">
            <div className="d-flex justify-content-center my-4">
              <div
                class=" text-center items-center spinner-border text-primary"
                style={{ width: "4rem", height: "4rem" }}
                role="status"
              ></div>
            </div>
          </div>
        ) : (
          <div className="wrapper emp-details-wrapper">
            <div className="heading-section">
              <div className="heading-wrapper">
                <ArrowLeft className="c-p" onClick={() => navigate(-1)} />
                <p>Registered Employee Details</p>
              </div>
              <div className="heading-wrapper" style={{ gap: "20px" }}>
                <Button
                  variant="primary"
                  onClick={handleDownloadEmployeeApplicationsCsv}
                  disabled={downloadingCsv}
                >
                  {downloadingCsv ? "Downloading…" : "Download Applications"}
                </Button>
              </div>
            </div>
            {users ? (
              <>
                <div className="user-details-section">
                  <div className="user-name">
                    <img src={users?.image || userImagePlaceholder} alt="user" />
                    <div className="name-phone">
                      <p>{users?.full_name}</p>
                      <p>{users?.national_id_number}</p>
                    </div>
                  </div>
                  <div className="user-details">
                    <div className="user-detail-item">
                      <p>Company Name</p>
                      <p>{users?.company?.company_name || "—"}</p>
                    </div>
                    <div className="user-detail-item">
                      <p>Employee Id</p>
                      <p>{users?.id || "—"}</p>
                    </div>
                    <div className="user-detail-item">
                      <p>Phone No.</p>
                      <p>{users?.phone || "—"}</p>
                    </div>
                    <div className="user-detail-item">
                      <p>Registration Date</p>
                      <p>
                        {users?.created_at
                          ? moment(users.created_at).format("MMMM D, YYYY")
                          : "—"}
                      </p>
                    </div>
                  </div>
                </div>


              </>
            ) : (
              <p className="text-center">Loading employee details...</p>
            )}
            <div className="previous-companies-wrapper">
              <p className="previous-heading">Current Company</p>
              <table className="">
                <thead className="table-header">
                  <tr>
                    <th>Company Name</th>
                    <th>Employee Id</th>
                    <th>From</th>
                    <th>To</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(users?.past_experience) &&
                    users.past_experience
                      .filter(item => item.is_current)
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{item.company_name}</td>
                          <td>{users?.id}</td>
                          <td>{moment(item.start_date).format("MMMM D, YYYY")}</td>
                          <td>
                            Present
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
            <div className="previous-companies-wrapper">
              <p className="previous-heading">Previous Companies</p>
              <table className="">
                <thead className="table-header">
                  <tr>
                    <th>Company Name</th>
                    <th>Employee Id</th>
                    <th>From</th>
                    <th>To</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(users?.past_experience) &&
                    users.past_experience
                      .filter(item => !item.is_current)
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{item.company_name}</td>
                          <td>{users?.id}</td>
                          <td>{moment(item.start_date).format("MMMM D, YYYY")}</td>
                          <td>
                            {item.end_date
                              ? moment(item.end_date).format("MMMM D, YYYY")
                              : moment(new Date()).format("MMMM D, YYYY")}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
            <div className="boxAppBoard boxWhite">
              <div className="boardHeader">
                <CheckboxFilter
                  setSearchTerm={setSearchTerm}
                  checkboxes={checkboxes}
                  setCheckboxes={setCheckboxes}
                />
                <div className="boardHeadRight">
                  <div className="searchForm">
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={handleInputChange}
                      value={searchTerm}
                    />
                    <button>
                      <img src={iconSearch} alt="" />
                    </button>
                  </div>
                  <div className="datePicker"></div>
                </div>
              </div>
              <div className="boardContent">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                          {headerGroup.headers.map((header) => (
                            <th key={header.id}>
                              {flexRender(
                                header.column.columnDef.header,
                                header.getContext()
                              )}
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody>
                      {table.getRowModel().rows.length > 0 ? (
                        table.getRowModel().rows.map((row) => (
                          <tr key={row.id}>
                            {row.getVisibleCells().map((cell) => (
                              <td key={cell.id}>
                                {flexRender(
                                  cell.column.columnDef.cell,
                                  cell.getContext()
                                )}
                              </td>
                            ))}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={table.getHeaderGroups()?.[0]?.headers.length}
                            style={{ textAlign: "center", padding: "20px" }}
                          >
                            No applications found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Pagination */}
              <Pagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={getTotalPages()}
                totalItems={data.length}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default EmployeeDetails;
